window.xUtils = {
  isMobile() {
    const userAgentIsMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const screenIsMobile = window.innerWidth <= 750;

    return userAgentIsMobile || screenIsMobile;
  },

  showMask() {
    let $mask = document.querySelector('.x-mask');
    if (!$mask) {
      $mask = document.createElement('div');
      $mask.innerText = ' ';
      $mask.classList.add('x-mask');
      document.body.appendChild($mask);
    }
    $mask.style.display = 'block';
    document.body.style.overflow = 'hidden';
  },
  hideMask() {
    const $mask = document.querySelector('.x-mask');
    if ($mask) {
      $mask.style.display = 'none';
    }
    document.body.style.overflow = '';
  },

  // set attribute customer_country on cart.attributes
  // if param countryCode is null, get localStorage value
  setCostomerCountry(countryCode, callback) {
    const cacheCode = localStorage.getItem('customerCountryCode');

    if (!countryCode && !cacheCode) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { customer_country: countryCode || cacheCode } }),
    }).then(() => {
      // save country code
      localStorage.setItem('customerCountryCode', countryCode);
      callback && callback();
    });
  },
  updateUrl(params) {
    if (!params) return;

    const url = new URL(window.location);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }

    window.history.replaceState({}, '', url);
  },

  getUrlParams() {
    const url = new URL(window.location);
    const params = Object.fromEntries(url.searchParams);

    for (const key in params) {
      params[key] = decodeURIComponent(params[key]);
    }
    return params;
  },

  showLoading() {
    let $loading = document.querySelector('#global-loading-mask');
    if (!$loading) {
      $loading = document.createElement('div');
      $loading.id = 'global-loading-mask';
      $loading.innerHTML = '<div class="global-spinner">Loading</div>';
      document.body.appendChild($loading);
    }

    $loading.style.display = 'flex';
  },

  hideLoading() {
    const $loading = document.querySelector('#global-loading-mask');
    if ($loading) {
      $loading.style.display = 'none';
    }
  },
  /**
   * validate email
   * @param {string} email - user input
   * @returns {Object} - result: {isValid: boolean, message: string}
   */
  validateEmail(email) {
    // 1. Empty Check
    if (!email || email.trim() === '') {
      return {
        isValid: false,
        message: 'Email address is required.',
      };
    }

    // 2. Length Check
    if (email.length > 254) {
      return {
        isValid: false,
        message: 'Email address is too long.',
      };
    }

    // 3. Format Check
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(email)) {
      return {
        isValid: false,
        message: 'Please enter a valid email address (e.g., name@example.com).',
      };
    }

    // 4. Validate Success
    return {
      isValid: true,
      message: 'Looks good!',
    };
  },
  /**
   * 格式化 Shopify 变体价格（分转元）
   * @param {number|string} cents - 以分为单位的价格
   * @returns {string} 格式化后的价格字符串
   */
  formatVariantPrice(cents) {
    // 确保转换为数字，并转化为“元”
    const price = Number(cents) / 100;

    if (isNaN(price)) return '0';

    // 判断是否有小数位（如果模 1 不等于 0，说明有分位）
    const hasCents = price % 1 !== 0;

    // 使用 en-US 格式（逢3位加逗号）
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0,
    }).format(price);
  },
};
